export default {
    setAircrewRoles(state, aircrewRoles) {
        state.aircrewRoles = aircrewRoles;
    },
}